import React from "react";

/**
 * The X (formerly Twitter) logo.
 *
 * Inlined rather than taken from @icons-pack/react-simple-icons: the pinned
 * v4 of that package predates the 2023 rebrand and only ships the old bird.
 *
 * Path data from Simple Icons (CC0 1.0 Universal).
 */
export const XIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>X</title>
    <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z" />
  </svg>
);

export default XIcon;
